<template>
	<div id="app">
		<div class="app-content">

			<home v-if="app.screen === 'home'" />
			<game v-if="app.screen === 'game'" />

		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Home from '@/components/home'
import Game from '@/components/game'

export default {
	name: 'App',
	computed: {
		...mapGetters([ 'app' ])
	},
	mounted() {
		this.$store.dispatch('init_app')
	},
	components: { Home, Game }
}
</script>

<style lang="stylus">
@import './assets/css/reset'
@import './assets/css/variables'

body
	background-color dark
	color light

.prevent-over
	absolute 0
	z-index 20

</style>
